// Ekstrak ID video YouTube dari berbagai format URL yang umum dipakai.
export const parseYouTubeId = (url) => {
  if (!url || typeof url !== "string") return null;
  const u = url.trim();
  if (!u) return null;

  // Pastikan benar-benar domain YouTube dulu supaya URL lain yang kebetulan
  // punya "?v=..." tidak salah dianggap video.
  if (!/(?:youtube\.com|youtube-nocookie\.com|youtu\.be)/i.test(u)) return null;

  // youtu.be/<id>
  let m = u.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);

  // youtube.com/watch?v=<id> — "v" bisa jadi parameter pertama atau setelah "&".
  if (!m) m = u.match(/[?&]v=([A-Za-z0-9_-]{11})/);

  // youtube.com/<embed|shorts|live|v>/<id>
  if (!m) m = u.match(/\/(?:embed|shorts|live|v)\/([A-Za-z0-9_-]{11})/);

  return m ? m[1] : null;
};

export const isYouTubeUrl = (url) => !!parseYouTubeId(url);

// hqdefault.jpg (480×360, 4:3 dengan letterbox) — dipotong lewat object-fit:
// cover di sisi render, sehingga tetap tampil 16:9 tanpa bar hitam.
export const getYouTubeThumbnail = (id, quality = "hq") =>
  id ? `https://i.ytimg.com/vi/${id}/${quality === "mq" ? "mqdefault" : "hqdefault"}.jpg` : null;
